//DEFINE THE ACTIONS TO TRIGGER
export const GET_ABMCONSULTA_LOADING = 'GET_ABMCONSULTA_LOADING';
export const GET_ABMCONSULTA_FAIL = 'GET_ABMCONSULTA_FAIL';
export const GET_ABMCONSULTA_SUCCESS = 'GET_ABMCONSULTA_SUCCESS';


export type ABMConsultaType =  {
    client_access_id: number,
    client_access_name:string,
    client_access_permissions:string,
};

export interface GetABMConsultaLoading {
    type: typeof GET_ABMCONSULTA_LOADING
}

export interface GetABMConsultaFail {
    type: typeof GET_ABMCONSULTA_FAIL
}

export interface GetABMConsultaSuccess {
    type: typeof GET_ABMCONSULTA_SUCCESS,
    payload: ABMConsultaType[] | undefined
}

export type GetABMCONSULTADispatchTypes = GetABMConsultaLoading | GetABMConsultaFail | GetABMConsultaSuccess;